import React, { useState, useEffect } from "react";
import "./style/Home.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faTh } from "@fortawesome/free-solid-svg-icons";
import BookCard from "../components/cards/BookCard";
import axios from "axios";
import BookCard2 from "../components/cards/BookCard2";
import Loading from "../components/Loading";

function Home() {
  const [books, setBooks] = useState();
  const [books2, setBooks2] = useState();
  const [line, setLine] = useState("false");
  const [box, setBox] = useState("true");
  const [colorBox, setColorBox] = useState("#b4d7f7");
  const [colorLine, setColorLine] = useState("grey");
  const [style, setStyle] = useState();

  const styleBox = {
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    flexWrap: "wrap",
  };

  const styleLine = {
    display: "block",
  };

  const styleCard = {
    display: "flex",
  };
  useEffect(() => {
    const data = axios
      .get(
        `https://www.googleapis.com/books/v1/volumes?q=Featured&maxResults=4`
      )
      .then((res) => res.data.items)
      .then((res) => setBooks(res));
    const data2 = axios
      .get(`https://www.googleapis.com/books/v1/volumes?q=New&maxResults=40`)
      .then((res) => res.data.items)
      .then((res) => setBooks2(res));
  }, []);

  const handleBox = () => {
    if (box === "false") {
      setBox("true");
      setLine("false");
      setColorBox("#b4d7f7");
      setColorLine("grey");
      setStyle(styleBox);
    }
    console.log("box value >>>>> ", box);
    console.log("line value >>>>> ", line);
  };

  const handleLine = () => {
    if (line === "false") {
      setBox("false");
      setLine("true");
      setColorBox("grey");
      setColorLine("#b4d7f7");
      setStyle(styleLine);
    }
    console.log("line value >>>>> ", line);
    console.log("box value >>>>> ", box);
  };

  return (
    <div className="home">
      <div className="featured">
        <div className="top">
          <h2>Featured Books</h2>
          <div>show all</div>
        </div>
        <div className="featured__book">
          {books ? (
            books?.map((book) => {
              return (
                <BookCard
                  key={book.id}
                  src={
                    !book.volumeInfo.imageLinks?.thumbnail
                      ? "https://via.placeholder.com/90x90.png"
                      : book.volumeInfo.imageLinks.thumbnail
                  }
                  title={book.volumeInfo.title}
                  rating={book.volumeInfo.averageRating}
                  prix={
                    book.saleInfo.saleability === "NOT_FOR_SALE"
                      ? 30
                      : book.saleInfo.saleability
                  }
                  author={book.volumeInfo.authors}
                  desc={book.volumeInfo.description}
                  id={book.id}
                />
              );
            })
          ) : (
            <Loading />
          )}
        </div>
      </div>
      <div className="new">
        <div className="top">
          <h2>New Books</h2>
          <div>
            <FontAwesomeIcon
              icon={faBars}
              onClick={handleLine}
              style={{ color: colorLine }}
            />
            <FontAwesomeIcon
              icon={faTh}
              onClick={handleBox}
              style={{ color: colorBox }}
            />
          </div>
        </div>
        <div className="new__book" style={style}>
          {line === "true" ? (
            books2 ? (
              books2?.map((book) => {
                return (
                  <BookCard2
                    key={book.id}
                    src={
                      !book.volumeInfo.imageLinks?.thumbnail
                        ? "https://via.placeholder.com/90x90.png"
                        : book.volumeInfo.imageLinks.thumbnail
                    }
                    title={book.volumeInfo.title}
                    rating={book.volumeInfo.averageRating}
                    prix={
                      book.saleInfo.saleability === "NOT_FOR_SALE"
                        ? 30
                        : book.saleInfo.saleability
                    }
                    author={book.volumeInfo.authors}
                    desc={book.volumeInfo.description}
                    id={book.id}
                    style={styleCard}
                  />
                );
              })
            ) : (
              <Loading />
            )
          ) : books2 ? (
            books2?.map((book) => {
              return (
                <BookCard
                  key={book.id}
                  src={
                    !book.volumeInfo.imageLinks?.thumbnail
                      ? "https://via.placeholder.com/90x90.png"
                      : book.volumeInfo.imageLinks.thumbnail
                  }
                  title={book.volumeInfo.title}
                  rating={book.volumeInfo.averageRating}
                  prix={
                    book.saleInfo.saleability === "NOT_FOR_SALE"
                      ? 30
                      : book.saleInfo.saleability
                  }
                  author={book.volumeInfo.authors}
                  desc={book.volumeInfo.description}
                  id={book.id}
                />
              );
            })
          ) : (
            <Loading />
          )}
        </div>
      </div>
    </div>
  );
}

export default Home;
